import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getShipmentsNoShipments,
    getShipmentsNoCustomers,
    getShipmentsTotalCost,
    getShipmentsBaseCost,
    getShipmentsAverageCost,
    getShipmentsAverageShippedWeight,
    getShipmentsAverageBilledWeight,
    getShipmentsNoShipmentsByTimeframe,
    getShipmentsCarriers,
    getShipmentsDestinations,
    getShipmentsSources,
    getShipmentsShippedWeights,
    getShipmentsBilledWeights,
    getShipmentsCarrierWeights,
    getShipmentsTotalCostByTimeframe,
    getShipmentsCountByZipCode,
    getShipFromLocations,
    getAggregatedCostByService,
} from '../../helpers';
import {
    shipmentsKpisApiResponseSuccess,
    shipmentsKpisApiResponseError,
} from './actions';
import { ShipmentsKpisActionTypes } from './constants';
import { addToast } from '../actions';

export function* getShipmentsNoShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsNoShipments, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST, error));
    }
}

export function* getShipmentsNoCustomersSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsNoCustomers, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST, error));
    }
}

export function* getShipmentsTotalCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsTotalCost, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST, error));
    }
}

export function* getShipmentsBaseCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsBaseCost, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST, error));
    }
}

export function* getShipmentsAverageCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsAverageCost, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST, error));
    }
}

export function* getShipmentsAverageShippedWeightSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsAverageShippedWeight, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST, error));
    }
}

export function* getShipmentsAverageBilledWeightSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsAverageBilledWeight, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST, error));
    }
}

export function* getShipmentsNoShipmentsByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsNoShipmentsByTimeframe, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST, error));
    }
}

export function* getShipmentsCarriersSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCarriers, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST, error));
    }
}

export function* getShipmentsDestinationsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsDestinations, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST, error));
    }
}

export function* getShipmentsSourcesSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsSources, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST, error));
    }
}

export function* getShipmentsShippedWeightsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsShippedWeights, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST, error));
    }
}

export function* getShipmentsBilledWeightsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsBilledWeights, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST, error));
    }
}

export function* getShipmentsCarrierWeightsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCarrierWeights, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST, error));
    }
}

export function* getShipmentsTotalCostByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsTotalCostByTimeframe, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST, error));
    }
}


export function* getShipmentsCountByZipCodeSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentsCountByZipCode, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE, error));
    }
}

export function* getShipFromLocationsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipFromLocations, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS, error));
    }
}

export function* getAggregatedCostByServiceSaga({ payload: { query } }) {
    try {
        const response = yield call(getAggregatedCostByService, query);
        yield put(shipmentsKpisApiResponseSuccess(ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE, response.data));
    } catch (error) {
        yield put(shipmentsKpisApiResponseError(ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE, error));
    }
}

export function* watchGetShipmentsNoShipmentsSaga(): any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_REQUEST, getShipmentsNoShipmentsSaga);
}

export function* watchGetShipmentsNoCustomersSaga(): any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_CUSTOMERS_REQUEST, getShipmentsNoCustomersSaga);
}

export function* watchGetShipmentsTotalCostSaga(): any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_REQUEST, getShipmentsTotalCostSaga);
}

export function* watchGetShipmentsBaseCostSaga(): any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_BASE_COST_REQUEST, getShipmentsBaseCostSaga);
}

export function* watchGetShipmentsAverageCostSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_COST_REQUEST, getShipmentsAverageCostSaga);
}

export function* watchGetShipmentsAverageShippedWeightSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_SHIPPED_WEIGHT_REQUEST, getShipmentsAverageShippedWeightSaga);
}

export function* watchGetShipmentsAverageBilledWeightSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_AVG_BILLED_WEIGHT_REQUEST, getShipmentsAverageBilledWeightSaga);
}

export function* watchGetShipmentsNoShipmentsByTimeframeSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_NO_SHIPMENTS_BY_TIMEFRAME_REQUEST, getShipmentsNoShipmentsByTimeframeSaga);
}

export function* watchGetShipmentsCarriersSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIERS_REQUEST, getShipmentsCarriersSaga);
}

export function* watchGetShipmentsDestinationsSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_DESTINATIONS_REQUEST, getShipmentsDestinationsSaga);
}

export function* watchGetShipmentsSourcesSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_SOURCES_REQUEST, getShipmentsSourcesSaga);
}

export function* watchGetShipmentsShippedWeightsSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_SHIPPED_WEIGHTS_REQUEST, getShipmentsShippedWeightsSaga);
}

export function* watchGetShipmentsBilledWeightsSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_BILLED_WEIGHTS_REQUEST, getShipmentsBilledWeightsSaga);
}

export function* watchGetShipmentsCarrierWeightsSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_CARRIER_WEIGHTS_REQUEST, getShipmentsCarrierWeightsSaga);
}

export function* watchGetShipmentsTotalCostByTimeframeSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_TOTAL_COST_BY_TIMEFRAME_REQUEST, getShipmentsTotalCostByTimeframeSaga);
}

export function* watchGetShipmentsCountByZipCodeSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIPMENTS_COUNT_BY_ZIP_CODE, getShipmentsCountByZipCodeSaga);
}

export function* watchGetShipFromLocationsSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_SHIP_FROM_LOCATIONS, getShipFromLocationsSaga);
}

export function* watchGetAggregatedCostByServiceSaga() : any {
    yield takeLatest(ShipmentsKpisActionTypes.GET_AGGREGATED_COST_BY_SERVICE, getAggregatedCostByServiceSaga);
}

function* shipmentsKpisSaga() {
    yield all([
        fork(watchGetShipmentsNoCustomersSaga),
        fork(watchGetShipmentsNoShipmentsSaga),
        fork(watchGetShipmentsTotalCostSaga),
        fork(watchGetShipmentsBaseCostSaga),
        fork(watchGetShipmentsAverageCostSaga),
        fork(watchGetShipmentsAverageShippedWeightSaga),
        fork(watchGetShipmentsAverageBilledWeightSaga),
        fork(watchGetShipmentsNoShipmentsByTimeframeSaga),
        fork(watchGetShipmentsCarriersSaga),
        fork(watchGetShipmentsDestinationsSaga),
        fork(watchGetShipmentsSourcesSaga),
        fork(watchGetShipmentsShippedWeightsSaga),
        fork(watchGetShipmentsBilledWeightsSaga),
        fork(watchGetShipmentsCarrierWeightsSaga),
        fork(watchGetShipmentsTotalCostByTimeframeSaga),
        fork(watchGetShipmentsCountByZipCodeSaga),
        fork(watchGetShipFromLocationsSaga),
        fork(watchGetAggregatedCostByServiceSaga),
    ]);
}

export default shipmentsKpisSaga;
